import endpoints from "./endpoints";
import api from "./api";
import { ProgressType } from "@medapro-types/common/common-enum";

export default {
  getLanguages() {
    return api.get(endpoints.languages.get).then((x) => Promise.resolve(x.data));
  },
  getAllUsers: async function () {
    const result = await api.get(endpoints.user.list.get).then((x) => Promise.resolve(x.data));
    return result;
  },
  getAllUsersDetails: async function () {
    const result = await api.get(endpoints.user.list.details).then((x) => Promise.resolve(x.data));
    return result;
  },
  updateUsers: async function (users) {
    const result = await api.post(endpoints.user.list.updateUsers, users);
    return result.data;
  },
  createUsers: async function (users) {
    const result = await api.post(endpoints.user.list.createUsers, users);
    return result.data;
  },
  deleteUsers: async function (usersIdList) {
    const result = await api.post(endpoints.user.list.deleteUsers, usersIdList);
    return result.data;
  },
  getLanguageRegions(language, localeLanguage) {
    return api
      .get(endpoints.languageRegions.get, {
        params: { language, localeLanguage }
      })
      .then((x) => Promise.resolve(x.data));
  },
  getEncodings(useBOMSpecificEncodings) {
    return api
      .get(endpoints.encodings.get, {
        params: { useBOMSpecificEncodings }
      })
      .then((x) => Promise.resolve(x.data));
  },
  getLanguagesWithLocalizedName(languageCode) {
    return api.get(endpoints.localizedLanguages.get, { params: { languageCode } }).then((x) => Promise.resolve(x.data));
  },
  getLocalizedBooleanValues(languages) {
    return api.get(endpoints.attributeManager.localizedBooleanValues.get, { params: { languages } }).then((x) => Promise.resolve(x.data));
  },
  getLog: async function (runId, module) {
    const response = {};
    let params = {};
    let apiURL = {};
    if (module == ProgressType.Export) {
      apiURL = endpoints.exports.getLog;
      params = { exportRunId: runId };
    } else if (module == ProgressType.Import) {
      apiURL = endpoints.import.getLog;
      params = { importRunId: runId };
    }
    try {
      const resp = await api.get(apiURL, { params: params });
      response.logs = resp.data;
    } catch (error) {
      if (error && error.isAxiosError) {
        if (error.response.status === 400) {
          if (error.response.data.language) response.error = error.response.data.language[0];
          else if (error.response.data.exportRunId) response.error = error.response.data.exportRunId[0];
          else if (error.response.data.importRunId) response.error = error.response.data.importRunId[0];
        } else if (error.response.status === 409) response.error = error.response.data.error;
      }
    }
    return response;
  }
};
